import {Directive} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {HostListener} from '@angular/core';
import {OnDestroy} from '@angular/core';
import {OnInit} from '@angular/core';
import {Output} from '@angular/core';

import {IInputFile} from './file.model';
import {AbstractInputFileDirective} from './abstract-input-file.directive';

@Directive({ selector: '[upload]' })
export class InputFileDirective extends AbstractInputFileDirective implements OnDestroy, OnInit {

    private _input: HTMLInputElement;

    @Output()
    upload = new EventEmitter<IInputFile[]>();

    ngOnDestroy(): void {
        document.body.removeChild(this._input);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this._input = document.createElement('input');
        this._input.type = 'file';
        this._input.style.height = '0px';
        this._input.style.opacity = '0';
        this._input.style.position = 'fixed';
        this._input.style.visibility = 'hidden';
        this._input.style.width = '0px';
        this._input.setAttribute('accept', this._accept.toString());
        if (this._multiple) {
            this._input.setAttribute('multiple', 'multiple');
        }
        this._input.addEventListener('change', () => {
            const files = this._onFileSelect(this._input.files);
            this.upload.emit(files);
            this._input.value = null;
        });
        document.body.appendChild(this._input);
    }

    @HostListener('click')
    private _onClick(): void {
        const event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        this._input.dispatchEvent(event);
    }
}